import { useCallback, useEffect, useState } from 'react';

type Theme = 'light' | 'dark';
const KEY = 'ecomstat-dam-theme';

function stored(): Theme {
  const v = localStorage.getItem(KEY);
  return v === 'dark' ? 'dark' : 'light'; // light is the default
}
function apply(theme: Theme) {
  document.documentElement.classList.toggle('dark', theme === 'dark');
  document.documentElement.style.colorScheme = theme;
}
export function applyThemeEarly() {
  apply(stored());
}
export function useTheme() {
  const [theme, setTheme] = useState<Theme>(stored);
  useEffect(() => apply(theme), [theme]);
  const toggle = useCallback(() => {
    setTheme((p) => {
      const n = p === 'dark' ? 'light' : 'dark';
      localStorage.setItem(KEY, n);
      return n;
    });
  }, []);
  return { theme, toggle };
}
